export const types = {
  CLEANUP_DOCUMENT: '@GED/CLEANUP_DOCUMENT',
  FETCH_DOCUMENT: '@GED/FETCH_DOCUMENT',
  FETCH_DOCUMENT_SUCCESS: '@GED/FETCH_DOCUMENT_SUCCESS',
  FETCH_DOCUMENT_ERROR: '@GED/FETCH_DOCUMENT_ERROR',
  UNSET_DOCUMENT: '@GED/UNSET_DOCUMENT',
  UPLOAD_GED_FILE: '@GED/UPLOAD_GED_FILE',
  UPLOAD_GED_FILE_SUCCESS: '@GED/UPLOAD_GED_FILE_SUCCESS',
  UPLOAD_GED_FILE_ERROR: '@GED/UPLOAD_GED_FILE_ERROR',
  CLEAR_UPLOAD_GED_FILE: '@GED/CLEAR_UPLOAD_GED_FILE',
  SAVE_DOCUMENT: '@GED/SAVE_DOCUMENT',
  SAVE_DOCUMENT_SUCCESS: '@GED/SAVE_DOCUMENT_SUCCESS',
  SAVE_DOCUMENT_ERROR: '@GED/SAVE_DOCUMENT_ERROR',
  TOGGLE_NEW_MULTIPLE_FIELD: '@GED/TOGGLE_NEW_MULTIPLE_FIELD',
  SET_MULTIPLE: '@GED/SET_MULTIPLE',
  DELETE_DOCUMENTS: '@GED/DELETE_DOCUMENTS',
  DELETE_DOCUMENTS_SUCCESS: '@GED/DELETE_DOCUMENTS_SUCCESS',
  DELETE_DOCUMENTS_ERROR: '@GED/DELETE_DOCUMENTS_ERROR',
  UPDATE_STATUS_DOCUMENTS: '@GED/UPDATE_STATUS_DOCUMENTS',
  UPDATE_STATUS_DOCUMENTS_SUCCESS: '@GED/UPDATE_STATUS_DOCUMENTS_SUCCESS',
  UPDATE_STATUS_DOCUMENTS_ERROR: '@GED/UPDATE_STATUS_DOCUMENTS_ERROR',
  UNLOCK_DOCUMENT: '@GED/UNLOCK_DOCUMENT',
  FAST_GED_OPEN: '@FAST_GED/FAST_GED_OPEN',
  FAST_GED_CLOSE: '@FAST_GED/FAST_GED_CLOSE',
};

export const cleanupDocument = (id) => ({
  type: types.CLEANUP_DOCUMENT,
  id,
});

export const fetchDocument = ({ id, base, variant }) => ({
  type: types.FETCH_DOCUMENT,
  id,
  base,
  variant,
});

export const fetchDocumentSuccess = (results) => ({
  type: types.FETCH_DOCUMENT_SUCCESS,
  results,
});

export const fetchDocumentError = (response) => ({
  type: types.FETCH_DOCUMENT_ERROR,
  response,
});

export const unsetDocument = () => ({
  type: types.UNSET_DOCUMENT,
});

export const clearUploadGEDFile = (fieldName) => ({
  type: types.CLEAR_UPLOAD_GED_FILE,
  fieldName,
});

export const toggleNewMultipleField = (fieldName) => ({
  type: types.TOGGLE_NEW_MULTIPLE_FIELD,
  fieldName,
});

export const saveDocument = (params, afterSave) => ({
  type: types.SAVE_DOCUMENT,
  params,
  afterSave,
});

export const saveDocumentSuccess = (results) => ({
  type: types.SAVE_DOCUMENT_SUCCESS,
  results,
});

export const saveDocumentError = (response) => ({
  type: types.SAVE_DOCUMENT_ERROR,
  response,
});

export const setMultiple = (multiple) => ({
  type: types.SET_MULTIPLE,
  multiple,
});

export const deleteDocuments = (refresh) => ({
  type: types.DELETE_DOCUMENTS,
  refresh,
});

export const deleteDocumentsSuccess = (results) => ({
  type: types.DELETE_DOCUMENTS_SUCCESS,
  results,
});

export const deleteDocumentsError = (response) => ({
  type: types.DELETE_DOCUMENTS_ERROR,
  response,
});

export const updateStatusDocuments = (status, refresh) => ({
  type: types.UPDATE_STATUS_DOCUMENTS,
  status,
  refresh,
});

export const updateStatusDocumentsSuccess = (results) => ({
  type: types.UPDATE_STATUS_DOCUMENTS_SUCCESS,
  results,
});

export const updateStatusDocumentsError = (response) => ({
  type: types.UPDATE_STATUS_DOCUMENTS_ERROR,
  response,
});

export const unlockDocument = (id) => ({
  type: types.UNLOCK_DOCUMENT,
  id,
});

export const fastGedOpen = (id, base, scope) => ({
  type: types.FAST_GED_OPEN,
  id,
  base,
  scope,
});

export const fastGedClose = () => ({
  type: types.FAST_GED_CLOSE,
});
